/**
 * Workbench role — UI layout aligned with billing plans (free Writer / Author / Editor).
 * Stored in book.metadata.workbenchPersona. Legacy values are normalized on read.
 */

export const WORKBENCH_PERSONAS = ["writer", "author", "editor"] as const;
export type WorkbenchPersona = (typeof WORKBENCH_PERSONAS)[number];

export const WORKBENCH_PERSONA_LABELS: Record<WorkbenchPersona, string> = {
  writer: "Writer",
  author: "Author",
  editor: "Editor",
};

const LEGACY_PERSONA: Record<string, WorkbenchPersona> = {
  novice: "writer",
  formatter: "author",
  publisher: "editor",
  writer: "writer",
  author: "author",
  editor: "editor",
};

export function parseWorkbenchPersona(value: unknown): WorkbenchPersona {
  if (typeof value === "string" && value in LEGACY_PERSONA) {
    return LEGACY_PERSONA[value]!;
  }
  return "writer";
}

export function personaFromBookMetadata(metadata: Record<string, unknown> | null | undefined): WorkbenchPersona {
  return parseWorkbenchPersona(metadata?.workbenchPersona);
}

/** Show full Publish / cover / preflight tools. */
export function showPublishSuite(persona: WorkbenchPersona): boolean {
  return persona === "author" || persona === "editor";
}

/** Writer sees a soft "Ready to publish?" entry, not the full suite by default. */
export function showPublishAsMilestone(persona: WorkbenchPersona): boolean {
  return persona === "writer";
}

/** Front/back matter insert in chapter ⋮ menu. */
export function showSpineMatterInsert(persona: WorkbenchPersona): boolean {
  return persona !== "writer";
}

/** Dual StoryCraft / score blend controls. */
export function showScoreBlendControls(persona: WorkbenchPersona): boolean {
  return persona === "author" || persona === "editor";
}

/** Client roster / engagements on desktop. */
export function showClientsRoster(persona: WorkbenchPersona): boolean {
  return persona === "editor";
}

/** Preflight + package language (store-ready). */
export function showPublisherPackaging(persona: WorkbenchPersona): boolean {
  return persona === "author" || persona === "editor";
}
